"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dropdown = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = (0, tslib_1.__importStar)(require("react"));
const classNameBuilders_1 = require("../../lib/classNameBuilders");
const DropdownMenu_1 = require("./DropdownMenu");
const DropdownTarget_1 = require("./DropdownTarget");
const ContextMenu_1 = require("../ContextMenu");
const createGUID_1 = require("../../lib/createGUID");
const Icon_1 = require("../../elements/Icon");
const getCoords = (element, position) => {
    const { top, left, width, height } = element.getBoundingClientRect();
    let point;
    switch (position) {
        case "top left":
            point = {
                x: left + window.pageXOffset,
                y: top + window.pageYOffset,
            };
            break;
        case "top center":
            point = {
                x: left + width / 2 + window.pageXOffset,
                y: top + window.pageYOffset,
            };
            break;
        case "top right":
            point = {
                x: left + width + window.pageXOffset,
                y: top + window.pageYOffset,
            };
            break;
        case "center left":
            point = {
                x: left + window.pageXOffset,
                y: top + height / 2 + window.pageYOffset,
            };
            break;
        case "center":
            point = {
                x: left + width / 2 + window.pageXOffset,
                y: top + height / 2 + window.pageYOffset,
            };
            break;
        case "center right":
            point = {
                x: window.innerWidth - (left + width + window.pageXOffset),
                y: top + height / 2 + window.pageYOffset,
            };
            break;
        case "bottom left":
            point = {
                x: left + window.pageXOffset,
                y: top + height + window.pageYOffset,
            };
            break;
        case "bottom center":
            point = {
                x: left + width / 2 + window.pageXOffset,
                y: top + height + window.pageYOffset,
            };
            break;
        case "bottom right":
            point = {
                x: left + width + window.pageXOffset,
                y: top + height + window.pageYOffset,
            };
            break;
    }
    return point;
};
function useOnClickOutside(element, callback) {
    (0, react_1.useEffect)(() => {
        const handleClickOutside = (ev) => {
            if (element.current && !element.current.contains(ev.target)) {
                callback();
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
}
const defaultProps = {
    menuTopPosition: "bottom",
    menuLeftOffset: 0,
    menuTopOffset: 0,
    align: "left",
};
const DropdownComponent = (props) => {
    const { className, menuTopPosition, children, withCaret, menuLeftOffset, menuTopOffset, includeHoverState, inButton, align, open, } = Object.assign({}, defaultProps, props);
    const [state, setState] = (0, react_1.useState)({ event: null });
    const [id, setId] = (0, react_1.useState)(() => (0, createGUID_1.createGUID)());
    const menu = (0, react_1.useRef)(null);
    const target = (0, react_1.useRef)(null);
    const reset = () => {
        setState({ event: null });
    };
    (0, react_1.useLayoutEffect)(() => {
        if (open === true) {
            const { x, y, width, height } = target.current.getBoundingClientRect();
            const event = new MouseEvent("click", {
                clientX: x + width,
                clientY: y + height,
            });
            setState((state) => (Object.assign(Object.assign({}, state), { event })));
        }
        else if (open === false) {
            reset();
        }
    }, [open]);
    let menuRight = 0;
    if (menu.current && align === "right") {
        const pos = menu.current.getBoundingClientRect();
        menuRight = window.innerWidth - (pos.left + pos.width + window.pageXOffset);
    }
    useOnClickOutside(menu, reset);
    const handleTargetClick = (evt) => {
        if (state.event) {
            reset();
            return;
        }
        evt.persist();
        const menuPosition = menu.current.getBoundingClientRect();
        const clientX = menuPosition.left + menuLeftOffset;
        const clientY = menuTopPosition === "bottom"
            ? menuPosition.top + menuPosition.height
            : menuPosition.top + menuTopOffset;
        const event = Object.assign(Object.assign({}, evt), { clientY,
            clientX, nativeEvent: Object.assign(Object.assign({}, evt.nativeEvent), { clientY,
                clientX, stopPropagation: evt.stopPropagation }), stopPropagation: evt.stopPropagation });
        setState({ event });
    };
    let menuChild, targetChild = null;
    react_1.default.Children.forEach(children, (child) => {
        if (child && child.type === DropdownMenu_1.DropdownMenu) {
            menuChild = child;
        }
        if (child && child.type === DropdownTarget_1.DropdownTarget) {
            targetChild = child;
        }
    });
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: (0, classNameBuilders_1.classnames)((0, classNameBuilders_1.bem)("dropdown", (0, classNameBuilders_1.use)(state.event, "--open"), (0, classNameBuilders_1.use)(inButton, "--in-btn")), className ? (0, classNameBuilders_1.bem)(className, (0, classNameBuilders_1.use)(state.event, "--open")) : null), ref: menu }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: (0, classNameBuilders_1.bem)("dropdown__target", (0, classNameBuilders_1.use)(includeHoverState, "--with-hover-state")), onClick: handleTargetClick, ref: target }, { children: [targetChild, " ", withCaret && ((0, jsx_runtime_1.jsx)(Icon_1.Icon, { name: "caretDown", className: "dropdown__target-icon" }, void 0))] }), void 0), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: (0, classNameBuilders_1.bem)("dropdown__menu") }, { children: (0, jsx_runtime_1.jsx)(ContextMenu_1.ContextMenu, Object.assign({ id: id, event: state.event, onClose: () => reset(), 
                    // className={align === 'right' ? 'left--0' : undefined}
                    className: (0, classNameBuilders_1.classnames)(align === "right" ? " left--0" : undefined), style: align === "right" ? { right: `${menuRight}px` } : undefined }, { children: menuChild.props.children }), void 0) }), void 0)] }), void 0));
};
class Dropdown extends react_1.Component {
    render() {
        return (0, jsx_runtime_1.jsx)(DropdownComponent, Object.assign({}, this.props), void 0);
    }
}
exports.Dropdown = Dropdown;
Dropdown.Menu = DropdownMenu_1.DropdownMenu;
Dropdown.Target = DropdownTarget_1.DropdownTarget;
Dropdown.Item = ContextMenu_1.ContextMenu.Item;
Dropdown.Separator = ContextMenu_1.ContextMenu.Separator;
Dropdown.SectionTitle = ContextMenu_1.ContextMenu.SectionTitle;
//# sourceMappingURL=Dropdown.js.map